import React, { useState, memo, useEffect } from "react";
import "./AdminDashboard.css";

const AdminLayout = memo(({ children, menuItems, currentPage, onMenuClick }) => {
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return (
    <div className="admin-dashboard-vertical">
      
      {/* MOBILE TOP BAR */}
      {isMobile && (
        <header className="mobile-header">
          <button
            className="menu-btn"
            onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
          >
            ☰
          </button>
        </header>
      )}

      {/* SIDEBAR */}
      <nav
        className={`sidebar 
          ${isSidebarExpanded ? "expanded" : ""} 
          ${isMobile ? "mobile" : ""}`}
        onMouseEnter={!isMobile ? () => setIsSidebarExpanded(true) : undefined}
        onMouseLeave={!isMobile ? () => setIsSidebarExpanded(false) : undefined}
      >
        {menuItems.map((item) => (
          <SidebarItem
            key={item.key}
            item={item}
            isActive={currentPage === item.key}
            isExpanded={isSidebarExpanded || !isMobile}
            onClick={() => {
              onMenuClick(item.key);
              if (isMobile) setIsSidebarExpanded(false);
            }}
          />
        ))}
      </nav>

      {/* MAIN CONTENT */}
      <div className="main-content">{children}</div>
    </div>
  );
});

const SidebarItem = memo(({ item, isActive, isExpanded, onClick }) => (
  <div className={`icon-group ${isActive ? "active" : ""}`} onClick={onClick}>
    <img
      src={process.env.PUBLIC_URL + `/assets/${item.icon}`}
      alt={item.label}
      loading="lazy"
    />
    {isExpanded && <p>{item.label}</p>}
  </div>
));

export default AdminLayout;
